import { render, staticRenderFns } from "./DiagnosesList.vue?vue&type=template&id=03d87c1c&scoped=true&"
import script from "./DiagnosesList.vue?vue&type=script&lang=js&"
export * from "./DiagnosesList.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosesList.vue?vue&type=style&index=0&id=03d87c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d87c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VBtnToggle,VIcon,VMenu,VTooltip})
